import React from "react";
import cx from "classnames";
import { useStaticQuery, graphql } from "gatsby";

import Resource from "~/models/resource";
import ResourceCard from "~/views/components/resource/card";

type Props = {
  className?: string;
  currentResource?: Resource;
};

function RecommendedResources({ className, currentResource }: Props) {
  const data: any = useStaticQuery(
    graphql`
      query resources {
        resources: allPageMdx(
          filter: { frontmatter: { type: { eq: "Resource" } } }
          sort: { fields: { releasedAt: DESC } }
          limit: 4
        ) {
          nodes {
            id
            frontmatter {
              id
              title
              type
              url {
                yamlId
                name
                pathname
              }
              labels {
                yamlId
                name
                slug
                description
              }
              releasedAt
              updatedAt
              description
              image {
                ...AssetFields
              }
            }
            excerpt
          }
        }
      }
    `
  );

  const resources = data.resources.nodes.map(
    (resource: any) => new Resource(resource as any)
  );

  return (
    <div className={cx(className)}>
      <p className="font-extrabold text-4xl text-neutral-90 mb-6">
        Recommended
      </p>

      <ul>
        {resources
          .filter((resource: any, index: number) =>
            currentResource ? resource.id != currentResource.id : index < 2
          )
          .map((resource: any) => (
            <li key={resource.id} className="mb-12 last:mb-0">
              <ResourceCard resource={resource} />
            </li>
          ))}
      </ul>
    </div>
  );
}

export default RecommendedResources;
